export default __webpack_public_path__ + "static/media/ArtistHeader.adbaffd1.jpg";